"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TwoColumnLayout() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="twocolumnlayout" className="w-full bg-background py-16 px-4 ![margin:-900px_0px_0px_0px] !h-[560px] md:py-24">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 items-center md:grid-cols-2 md:gap-16 lg:gap-20">
          {}
          <div ref={leftRef} className={`relative w-full -mt-10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative rounded-lg shadow-medium flex justify-center">
              <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/01/image_vzyujg3g.png" data-wvc-srcset="https://sincere-skink.10web.cloud/wp-content/uploads/2026/01/image_vzyujg3g.png-wvc-srcset" data-wvc-sizes="https://sincere-skink.10web.cloud/wp-content/uploads/2026/01/image_vzyujg3g.png-wvc-sizes" alt="Two column layout visual" loading="lazy" className="hidden md:block translate-x-[10px]" />
            </div>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-6 -mt-10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <h2 className="hidden font-display font-semibold text-foreground ![margin:-100px_0px_0px_0px] !text-[40px] md:block">Our Purpose Serving You</h2>
            <div className="flex flex-col gap-4">
              <p className="hidden text-muted-foreground leading-relaxed ![margin:-10px_0px_0px_0px] !text-xl md:block">Our purpose is to quickly evolve your leadership consciousness, capacity &amp; psychology to have the​ right strategic insights to make the right decisions that creates the right experience for you &amp; people.&nbsp;</p>
              <p className="hidden text-muted-foreground leading-relaxed !text-xl md:block">Our proven proprietary CEO Breakthrough Protection program enables 3-4x faster buy-in to deals & objectives to protect & enhance progress, company valuation & remuneration while being in anchored in great health enjoying more presence & time with family.</p>
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}